import { useEffect } from 'react';

// Attaches the "wheel scrolls this box, never the page behind it" rule to an element: it stops the wheel from reaching the page's
// own scroll script, and from chaining to it at the top or end of the box. A box with nothing to scroll lets the page scroll as
// usual. The listener is native (not React's) so it runs before the page's handler.
export const containWheel = el => {
  if (!el) return undefined;
  const onWheel = e => {
    if (el.scrollHeight <= el.clientHeight) return;
    e.stopPropagation();
    const atTop = el.scrollTop <= 0 && e.deltaY < 0;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1 && e.deltaY > 0;
    if (atTop || atBottom) e.preventDefault();
  };
  el.addEventListener('wheel', onWheel, { passive: false });
  return () => el.removeEventListener('wheel', onWheel);
};

// For a box held in a ref.
export const useContainWheel = ref => {
  useEffect(() => containWheel(ref.current));
};

export default useContainWheel;
